<template>
  <div
    class="index-for-md filter-none grid grid-cols-2 gap-x-10 md:gap-x-0 px-5 md:px-0 md:mt-10 md:flex"
  >
    <AboutStatItem
      v-for="item in statItems"
      :number="item.number"
      :text="item.title"
    />
  </div>
  <AboutWorldMap></AboutWorldMap>
  <section
    class="index-for-md body-text-style mb-12"
    v-html="bodyText"
  ></section>
  <div
    class="flex flex-col mt-8 relative z-10 md:flex md:flex-row md:m-14 md:mx-auto"
    v-if="teamMembers.length > 0"
  >
    <AboutMemberCard
      v-for="member in teamMembers"
      :name="member.name"
      :position="member.position"
      :image="member.image.permalink"
      :key="member.name"
    ></AboutMemberCard>
  </div>
</template>
<script setup>
let statItems = ref();
let bodyText = ref("");
let teamMembers = ref([]);
const props = defineProps({
  aboutUsRes: {
    type: Object,
  },
});

if (props.aboutUsRes.data) {
  statItems = props.aboutUsRes.data.achievements;
  bodyText = props.aboutUsRes.data.body_text;
  teamMembers = props.aboutUsRes.data.team_members;

  const pClass =
    "text-left md:text-center font-semibold text-lg md:w-full text-[#253754F2]";
  let counter = 0;
  bodyText = bodyText
    .replace(/<p>/g, (match) => {
      counter++;
      return counter == 2
        ? `<p class='${pClass} md:pl-2'>`
        : `<p class='${pClass} mb-6'>`;
    })
    .replace(
      /<h3>/g,
      "<h2 class='text-left md:text-center mb-6 font-bold text-space-cadet'>",
    );
}
</script>
<style scoped>
.index-for-md {
  @apply md:relative md:z-10;
}
.body-text-style {
  @apply mt-6 md:mt-16 md:w-4/6 md:mx-auto text-space-cadet;
}
</style>
